import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Image1 from '../images/EducateaChild.jpg'; // इमेज जोड़ें
import Image2 from '../images/SkillDevelopmentt.jpg'; // इमेज जोड़ें
import Image3 from '../images/EducateaChild.jpg'; // डमी इमेज (आप बदल सकते हैं)

const GallerySection: React.FC = () => {
  // इमेज गैलरी डेटा
  const images = [
    {
      src: Image1,
      title: 'Free Education Camp',
      desc: 'Organized a free education camp to support underprivileged children with learning opportunities and essential resources.',
    },
    {
      src: Image2,
      title: 'Skill Development Workshop',
      desc: 'Empowering youth through practical training and in-demand skills for better employment opportunities.',
    },
    {
      src: Image3,
      title: 'Women Empowerment Seminar',
      desc: 'A seminar focused on advancing gender equality and empowering women through awareness, dialogue, and opportunities',
    },
  ];

  // यूट्यूब वीडियो डेटा
  const videos = [
    {
      title: 'Our Mission in Action',
      url: '#', // डमी यूट्यूब लिंक (आप बदल सकते हैं)
    },
    {
      title: 'Skill Development Program',
      url: '#', // डमी यूट्यूब लिंक (आप बदल सकते हैं)
    },
    {
      title: 'Education for All',
      url: '#', // डमी यूट्यूब लिंक (आप बदल सकते हैं)
    },
  ];

  return (
    <section className="gallery-section py-5">
      <Container>
        {/* पहला सेक्शन: इमेज गैलरी */}
        <div className="image-gallery mb-5">
          <h2 className="gallery-title text-center mb-5 mt-5">Image Gallery</h2>
          <Row>
            {images.map((image, index) => (
              <Col md={4} key={index} className="mb-4">
                <Card className="gallery-card">
                  <Card.Img variant="top" src={image.src} className="gallery-image" />
                  <Card.Body>
                    <Card.Title className="gallery-card-title">{image.title}</Card.Title>
                    <Card.Text className="gallery-card-text">{image.desc}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>

        {/* दूसरा सेक्शन: वीडियो गैलरी */}
        {/* <div className="video-gallery">
          <h2 className="gallery-title text-center mb-5">Video Gallery</h2>
          <Row>
            {videos.map((video, index) => (
              <Col md={4} key={index} className="mb-4">
                <div className="video-card">
                  <div className="video-wrapper">
                    <iframe
                      src={video.url}
                      title={video.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className="video-iframe"
                    ></iframe>
                  </div>
                  <h5 className="video-title">{video.title}</h5>
                </div>
              </Col>
            ))}
          </Row>
        </div> */}
      </Container>
    </section>
  );
};

export default GallerySection;